<template>
    <div class="flex min-h-full flex-col bg-white pt-16 pb-12">
        <main
            class="mx-auto flex w-full max-w-7xl flex-grow flex-col justify-center px-4 sm:px-6 lg:px-8"
        >
            <div class="flex flex-shrink-0 justify-center">
                <a href="/" class="inline-flex">
                    <span class="sr-only">IMMIVO</span>
                    <img
                        class="h-12 w-auto bg-minplan-blue p-3"
                        src="../../image/immivo.svg"
                        alt="immivo"
                    />
                </a>
            </div>
            <div class="py-16">
                <div class="text-center">
                    <p class="text-base font-semibold text-indigo-600">
                        {{ this.status }}
                    </p>
                    <h1
                        class="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl"
                    >
                        {{ $t("errors.title." + this.status) }}
                    </h1>
                    <p class="mt-2 text-base text-gray-500">
                        {{ $t("errors.detail." + this.status) }}
                    </p>
                    <!--           <div class="mt-6">
            <a href="#" class="text-base font-medium text-indigo-600 hover:text-indigo-500">
              Go back home
              <span aria-hidden="true"> &rarr;</span>
            </a>
          </div> -->
                </div>
            </div>
        </main>
        <footer class="mx-auto w-full max-w-7xl flex-shrink-0 px-4 sm:px-6 lg:px-8">
            <nav class="flex justify-center space-x-4">
                <a
                    href="mailto:michele.vonvacano@akkurat.ch?subject=IMMIVO%20Feedback"
                    class="text-sm font-medium text-gray-500 hover:text-gray-600"
                    >Support kontaktieren</a
                >
                <span class="inline-block border-l border-gray-300" aria-hidden="true" />
                <a href="/" class="text-sm font-medium text-gray-500 hover:text-gray-600"
                    >Startseite</a
                >
            </nav>
        </footer>
    </div>
</template>

<script>
export default {
    props: {
        status: Number,
    },
};
</script>
